import { AuthActionTypes, AuthActions } from '@app-stores/actions/auth.action';
import * as errorHandler from '@app-shared/utils/error-handler';
export interface State {
	error: string | null;
	message: string | null;
	pending: boolean;
	loginRequired: boolean;
}
export const initialState: State = {
	error: null,
	message: null,
	pending: false,
	loginRequired: false,
};
export function reducer(state = initialState, action: AuthActions): State {
	switch (action.type) {
		case AuthActionTypes.LoginWithToken:
		case AuthActionTypes.Login: {
			return {
				...state,
				error: null,
				pending: true,
				loginRequired: false,
				message: null,
			};
		}
		case AuthActionTypes.LoginSuccess: {
			return {
				...state,
				error: null,
				pending: false,
				loginRequired: false,
				message: action.payload['message'],
			};
		}
		case AuthActionTypes.LoginFailure: {
			return {
				...state,
				error: errorHandler.getHttpError(action.payload),
				pending: false,
				loginRequired: false,
			};
		}
		case AuthActionTypes.LoginRequired: {
			return {
				...state,
				error: null,
				pending: false,
				loginRequired: action.payload,
			};
		}
		default: {
			return state;
		}
	}
}
export const getMessage = (state: State) => state.message;
export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getLoginRequired = (state: State) => state.loginRequired;
